import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EcoImg from 'eco-design/base/eco-img';
import gtm from '@/utils/gtm';

const YoutubeVideo: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('YoutubeVideo');
    return (
        <div className={styles.YoutubeVideo}>
            <div className="lp-layout">
                <iframe
                    src="https://www.youtube.com/embed/Ut0GNwfbzV4?si=mJMM46i7ChdprFac"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                ></iframe>
            </div>
        </div>
    );
};

export default YoutubeVideo;
